import { render, staticRenderFns } from "./EidStart.vue?vue&type=template&id=22340f46&"
import script from "./EidStart.vue?vue&type=script&lang=js&"
export * from "./EidStart.vue?vue&type=script&lang=js&"
import style0 from "./EidStart.vue?vue&type=style&index=0&id=22340f46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports